/**
 *   统一API接口
 */

 //用户模块
 import user from '../js/user/user';

 //跟团游模块
 import tours from '../js/toursVip/tours';

 //商城模块
 import store from '../js/store/store';

 //优惠券
 import member from '../js/member/member';

 //会员卡
 import card from '../js/card/card';

 //客户模块
 import customer from '../js/customer/customer';

 //员工模块
 import staff from '../js/staff/staff';

 //发放模块
 import grant from '../js/grant/grant';

 //部门管理
 import department from '../js/department/department'

 //单页面
 import privacy from '../js/privacy/privacy'
 

 //导出接口
 export default{
    user,
    tours,
    store,
    member,
    card,
    customer,
    staff,
    grant,
    department,
    privacy
 }


// WEBPACK FOOTER //
// ./src/js/api.js